.page {
    display: flex;
    height: 100%;
    width: 100%;
    max-width: 1728px; /* dibdev constrainer: 108rem at 16px root */
    margin: 0 auto;
    overflow: hidden;
    /* Breathing room between the app bar and the first content row in
       any column. Matches dibdev (15px). */
    padding-top: 15px;
}

/* Responsive column collapse mirrors dibdev's generic-full layout:
   right sidebar drops below 1200px, TOC drops below 768px. Mobile-first
   to match the source (base = narrowest, min-width queries widen). */
.toc {
    display: none;
    height: 100%;
    overflow-y: auto;
    padding: 10px 0 0 0;
}

@media (min-width: 768px) {
    .toc {
        display: block;
        flex: 0 0 33%;
        max-width: 33%;
    }
}

@media (min-width: 1200px) {
    .toc {
        flex: 0 0 25%;
        max-width: 25%;
    }
}

.article {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
    /* position: relative is load-bearing — without it, the article's own
       scrollable content propagates upward and triggers the page-wide
       .mainContent scroll in the chat shell. */
    position: relative;
    height: 100%;
    overflow-y: auto;
    /* Horizontal padding matches legacy's `0 22.5px` (1.5 * 15px). */
    padding: 0 calc(var(--legacy-base) * 1.5);
    /* Offset scrollIntoView / hash-jump targets below the sticky .title
       (see HtmlArticleLEGACY.module.css). Roughly the title's full
       footprint: ~33px box + 15px top margin + 15px bottom margin. */
    scroll-padding-top: calc(var(--legacy-base) * 4);

    /* Article-shell base — referenced by HtmlArticleLEGACY.module.css. */
    --legacy-base: 0.9375rem;
    font-size: var(--legacy-base);
    line-height: 1.55;
    color: #333;
}

@media (min-width: 768px) {
    .article {
        flex: 0 0 67%;
        max-width: 67%;
    }
}

@media (min-width: 1200px) {
    .article {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

.related {
    display: none;
    height: 100%;
    overflow-y: auto;
    padding: var(--mantine-spacing-md);
}

@media (min-width: 1200px) {
    .related {
        display: block;
        flex: 0 0 25%;
        max-width: 25%;
    }
}
